import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'material-ui/Card';
import { Link } from 'react-router';
import { FormattedPlural } from 'react-intl';

const CategoryCard = ({category, courseCount, resourceCount, colour}) => (
    <Card className="cent-card cent-card-list-item">
        <Link to={`/dashboard/library/${category.id}`}>
            <div className="cent-category" style={{ borderColor: category.colour || colour }} >
                <div className="cent-category-header">{category.name}</div>
                <div className="cent-category-links">
                    <FormattedPlural
                        value={courseCount}
                        one='1 course '
                        other={`${courseCount} courses `}
                    />
                    { resourceCount > 0 && (
                        <FormattedPlural
                            value={resourceCount}
                            one='1 resource'
                            other={`${resourceCount} resources`}
                        />
                    )}
                </div>
            </div>
        </Link>
    </Card>
);


CategoryCard.propTypes = {
    category:   PropTypes.shape({
        id:     PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        name:   PropTypes.string.isRequired
    }),
    courseCount:    PropTypes.number,
    resourceCount:  PropTypes.number,
    colour:         PropTypes.string
};

CategoryCard.defaultProps = {
    courseCount:    0,
    resourceCount:  0,
    colour: 'rgb(31, 115, 146)'
};

export default CategoryCard;
